export default "__VITE_ASSET__BGECzEuZ__"